import { Component, OnInit, Input } from "@angular/core";
import { FormGroup, FormBuilder, Validators } from "@angular/forms";
import { AppService } from "../../../../services/app.service";
import { MasterService } from "../../../../services/master.service";

@Component({
    selector: 'app-dist-payment-detail',
    templateUrl: './dist-payment-detail.component.html',
    styleUrls: ['./dist-payment-detail.component.scss']
})
export class DistPaymentDetailComponent implements OnInit {
    @Input() parent: any;

formGroup: FormGroup;
formGroupErrors: any;
translations: any;
PaidToList: any = [];
oPaidTo = '';
showSaveButton : Boolean = true;
constructor(
    private formBuilder: FormBuilder,
    public appService: AppService,
    public masterService: MasterService
) {
    this.appService.showLoading();
    this.showSaveButton = !(sessionStorage.getItem("ViewMode") == 'true');
    this.setPageTranslations();

    this.formGroupErrors = {
        P_TotalAmount: {},
        P_DepositeAmount: {},
        P_OutstandingAmount: {},
        P_PaidTo: {},
        P_ActualPaid: {},
        P_ActualPaidRemark: {}
    };
}

ngOnInit() {

    this.loadFormGroup();
    this.bindPaidTo();
}

setPageTranslations() {
    this.translations = JSON.parse(sessionStorage.getItem("pageData"));
}
changeTotal(e){
    this.parent.order.P_OutstandingAmount =
        this.parent.order.P_TotalAmount - this.parent.order.P_DepositeAmount;
}
changeDeposite(e) {
    this.parent.order.P_OutstandingAmount =
        this.parent.order.P_TotalAmount - this.parent.order.P_DepositeAmount;
}

changeOutstanding(e) {
    this.parent.order.P_DepositeAmount =
        this.parent.order.P_TotalAmount - this.parent.order.P_OutstandingAmount;
}

bindPaidTo(): void {
    this.masterService
    .selectSysData("PaidTo", this.parent.order.P_PaidTo)
    .subscribe(
    res => this.getOrderTypesSuccess(res),
    error => this.apiFaillure(error)
    );
}

getOrderTypesSuccess(res): void {

    if (res.Data != null) {
        this.PaidToList = JSON.parse(res.Data);
        for(let i = 0; i< this.PaidToList.length; i++){
            if(this.parent.order.P_PaidTo == this.PaidToList[i].Id)
            {
                this.oPaidTo = this.PaidToList[i].Value;
            }
        }     

        this.appService.hideLoading();
    } else {
    this.apiFaillure(res.Message);
}
}

apiFaillure(error): void {
    this.appService.hideLoading();
    this.appService.showDialogue(
    this.translations.hdError,
    this.translations[error]
    );
}

loadFormGroup() {
    if (this.parent.order.Status == 152 && this.showSaveButton) {
        this.formGroup = this.formBuilder.group({
            P_TotalAmount: [{
                value: '',
                disabled: true
            },
                            [Validators.pattern(/^\d+(\.\d{1,2})?$/), Validators.required
                             ,Validators.max(99999.99),Validators.min(0)]
                           ],
            P_DepositeAmount: [
                {
                    value: '',
                    disabled: true
                },
                [Validators.pattern(/^\-?\d+(\.\d{1,2})?$/), Validators.required,Validators.max(99999.99),Validators.min(-99999.99)]
            ],
            P_OutstandingAmount: [
                {
                    value: '',
                    disabled: true
                },
                [Validators.pattern(/^\-?\d+(\.\d{1,2})?$/), Validators.required,Validators.max(99999.99),Validators.min(-99999.99)]
            ],
            P_PaidTo: [
                //                {
                //                value: '',
                //                disabled: true
                //            }, 
                Validators.required],
            P_ActualPaid: ["",[Validators.pattern(/^\-?\d+(\.\d{1,2})?$/), Validators.max(99999.99),Validators.min(-99999.99)]],
            P_ActualPaidRemark: [""]
        });
    } else {
        this.formGroup = this.formBuilder.group({
            P_TotalAmount: [
                {
                    value: '',
                    disabled: true
                },
                [Validators.pattern(/^\d+(\.\d{1,2})?$/), Validators.required]
            ],
            P_DepositeAmount: [
                {
                    value: '',
                    disabled: true
                },
                [Validators.pattern(/^\-?\d+(\.\d{1,2})?$/), Validators.required,Validators.max(99999.99),Validators.min(-99999.99)]
            ],
            P_OutstandingAmount: [
                {
                    value: '',
                    disabled: true
                },
                [Validators.pattern(/^\-?\d+(\.\d{1,2})?$/), Validators.required,Validators.max(99999.99),Validators.min(-99999.99)]
            ],
            P_PaidTo: [{value: "", disabled: !this.showSaveButton }
                //                {
                //                    value: '',
                //                    disabled: true
                //                }
            ],
            P_ActualPaid: [{value: "", disabled: !this.showSaveButton },[Validators.pattern(/^\-?\d+(\.\d{1,2})?$/), Validators.max(99999.99),Validators.min(-99999.99)]],
            P_ActualPaidRemark: [{value: "", disabled: !this.showSaveButton }]
        });
    }
    this.formGroup.valueChanges.subscribe(() => {
        this.formGroupErrors = this.appService.onFormValuesChanged(
            this.formGroup,
            this.formGroupErrors
        );
        this.appService.setFormValid(this.formGroup.invalid);
    });
}
changeColor(e){
    for(let i = 0; i< e.source.options.length; i++){
        if(e.value == e.source.options._results[i].value)
        {
            e.source._elementRef.nativeElement.firstElementChild.firstElementChild.style.color =  e.source.options._results[i]._element.nativeElement.style.color;
        }
    }
}
}



// WEBPACK FOOTER //
// D:/Keval/Project/Mindport/HRS/hantraco-app/src/app/main/content/components/distributor-order/distributor-order-edit-form/dist-payment-detail/dist-payment-detail.component.ts